var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9583 12.0833C13.2224 12.0833 12.546 12.3379 12.012 12.7635L8.67591 10.6784C8.77471 10.2315 8.77471 9.76844 8.67591 9.32155L12.012 7.23646C12.546 7.66214 13.2224 7.91666 13.9583 7.91666C15.6842 7.91666 17.0833 6.51754 17.0833 4.79166C17.0833 3.06579 15.6842 1.66666 13.9583 1.66666C12.2325 1.66666 10.8333 3.06579 10.8333 4.79166C10.8333 5.02467 10.859 5.25163 10.9074 5.47008L7.57129 7.55517C7.03734 7.12952 6.36094 6.875 5.625 6.875C3.89912 6.875 2.5 8.27412 2.5 10C2.5 11.7259 3.89912 13.125 5.625 13.125C6.36094 13.125 7.03734 12.8705 7.57129 12.4448L10.9074 14.5299C10.8581 14.7527 10.8333 14.9802 10.8333 15.2083C10.8333 16.9342 12.2325 18.3333 13.9583 18.3333C15.6842 18.3333 17.0833 16.9342 17.0833 15.2083C17.0833 13.4825 15.6842 12.0833 13.9583 12.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5292caef0ac44037e6980d1cba576109.svg";
export { ForwardRef as ReactComponent };